import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { CashierSetting } from "../../modules/cashierSetting/components/CashierSetting";

const CashierSettingContext = createContext();

const CashierSettingWrapper = () => {
  const value = {};

  return (
    <CashierSettingContext.Provider value={value}>
      <Routes>
        <Route path="" element={<CashierSetting />} />
      </Routes>
    </CashierSettingContext.Provider>
  );
};

export { CashierSettingWrapper };
